import { ChevronDown, ChevronRight, X } from "lucide-react";
import { useState } from "react";

import { DocumentBadge } from "@/taskpane/components/Badge/DocumentBadge";
import { Document } from "@/taskpane/types/Document";

interface LegalDocumentsResultProps {
	documents: Document[];
}

export function LegalDocumentsResult({ documents }: LegalDocumentsResultProps) {
	const [isOpen, setIsOpen] = useState(false);

	if (documents.length === 0) {
		return (
			<div className='flex items-center gap-2 text-sm italic text-base-content/70'>
				<X className='w-4 h-4' />
				<span>Aucune source trouvée</span>
			</div>
		);
	}

	const s = documents.length === 1 ? '' : 's';
	return (
		<div className='flex flex-col gap-2'>
			<button
				onClick={() => setIsOpen(!isOpen)}
				className='flex w-fit cursor-pointer items-center gap-2 text-sm italic text-base-content/70 transition-colors hover:text-base-content'
				aria-expanded={isOpen}
			>
				<div className='flex items-center gap-2'>
					<svg
						className='h-4 w-4 flex-shrink-0'
						fill='none'
						stroke='currentColor'
						viewBox='0 0 24 24'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth={2}
							d='M5 13l4 4L19 7'
						/>
					</svg>
					<span>
						{documents.length} source{s} trouvée{s}
					</span>
				</div>
				{isOpen ? (
					<ChevronDown className='h-4 w-4 text-base-content/50' />
				) : (
					<ChevronRight className='h-4 w-4 text-base-content/50' />
				)}
			</button>
			{isOpen && (
				<div className='flex flex-wrap gap-2 pt-1'>
					{documents.map((doc) => (
						<DocumentBadge
							key={doc.id}
							document={doc}
						/>
					))}
				</div>
			)}
		</div>
	);
}
